import {createContext} from 'react'
import {ExplorePaginationHandler} from 'types'

export const ExplorePaginationContext = createContext<
  ExplorePaginationHandler | undefined
>(undefined)
